$(document).ready(function(){
    $('.dropdown-menu .ld-item-list-item-preview, .course-list-group .ld-item-list-item-preview').click(function(e){
        if(e.target.nodeName.toLowerCase() !== 'a' && $(this).find('a').length){
            window.location = $(this).find('a').attr('href');
            e.preventDefault();
            return false;
        }
    });
});